import { LoadingOutlined } from '@ant-design/icons';
import { Alert } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useProcessingLock } from '@/contexts/processing-lock-context';
import { OPERATION_TYPE_KEY_MAP } from '@/features/batch-operations/utils';

function getElapsedText(startedAt?: string): string {
  if (!startedAt) return '';
  const elapsed = Math.floor(
    (Date.now() - new Date(startedAt).getTime()) / 1000,
  );
  if (elapsed < 5) return '';
  if (elapsed < 60) return `${elapsed}s`;
  const minutes = Math.floor(elapsed / 60);
  const seconds = elapsed % 60;
  return `${minutes}m ${seconds}s`;
}

export function ProcessingBanner() {
  const { isLocked, operationType, startedAt } = useProcessingLock();
  const [, setTick] = useState(0);
  const { t } = useTranslation();

  // Re-render every second to update elapsed time
  useEffect(() => {
    if (!isLocked || !startedAt) return;
    const interval = setInterval(() => setTick((tick) => tick + 1), 1000);
    return () => clearInterval(interval);
  }, [isLocked, startedAt]);

  if (!isLocked) return null;

  const opKey =
    operationType && OPERATION_TYPE_KEY_MAP[operationType]
      ? OPERATION_TYPE_KEY_MAP[operationType]
      : 'default';
  const label = t(`processingBanner.operationLabels.${opKey}`);
  const elapsed = getElapsedText(startedAt);
  const message = elapsed
    ? t('processingBanner.editingDisabledWithTime', { label, elapsed })
    : t('processingBanner.editingDisabled', { label });

  return (
    <Alert
      banner
      type="info"
      icon={<LoadingOutlined />}
      showIcon
      message={message}
      style={{ position: 'sticky', top: 64, zIndex: 29 }}
    />
  );
}
